import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import { useApiContext } from "../context/ApiContext.jsx";

const ProtectedFile = ({ fileObj, className, download = false, children }) => {
	const { api } = useApiContext();
	const [fileUrl, setFileUrl] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const urlRef = useRef(null); // ultimo objectURL
	const requestSeqRef = useRef(0); // per gestire race/abort

	useEffect(() => {
		const fileId = fileObj?.id;

		setFileUrl(null);
		setError(null);

		if (!fileId) return;

		const controller = new AbortController();
		const mySeq = ++requestSeqRef.current;

		const isCanceled = (err) =>
			err?.code === "ERR_CANCELED" ||
			err?.name === "CanceledError" ||
			axios.isCancel?.(err) === true;

		const fetchFile = async () => {
			setLoading(true);

			try {
				const res = await api.get(`/api/trivia/media/${fileId}`, {
					responseType: "blob",
					signal: controller.signal,
				});

				// se nel frattempo è partita un’altra richiesta, ignoro questa
				if (mySeq !== requestSeqRef.current) return;

				// cleanup del vecchio objectURL
				if (urlRef.current) {
					URL.revokeObjectURL(urlRef.current);
					urlRef.current = null;
				}

				const objectUrl = URL.createObjectURL(res.data);
				urlRef.current = objectUrl;
				setFileUrl(objectUrl);
			} catch (err) {
				// se è cancel/abort: non è un errore utente, ignoro
				console.log("isCanceled(err):", isCanceled(err))
				if (isCanceled(err)) return;

				// se è una risposta vecchia, ignoro
				if (mySeq !== requestSeqRef.current) return;

				console.error("ProtectedFile error:", err);
				setError("Errore nel caricamento del file");
			} finally {
				if (mySeq === requestSeqRef.current) {
					setLoading(false);
				}
			}
		};

		fetchFile();

		return () => {
			controller.abort();

			// NOTA: non revocare qui l’objectURL “corrente” se potrebbe essere usato
			// da un render successivo. Lo gestiamo quando arriva un nuovo blob o unmount.
		};
	}, [api, fileObj?.id]);

	useEffect(() => {
		return () => {
			// cleanup finale all’unmount
			if (urlRef.current) {
				URL.revokeObjectURL(urlRef.current);
				urlRef.current = null;
			}
		};
	}, []);

	if (loading) return <div>Caricamento file…</div>;
	if (error) return <div role="alert">{error}</div>;
	if (!fileUrl) return null;

	return (
		<>
			{fileObj?.isImage && !download ? (
				<img src={fileUrl} className={className} alt={fileObj?.name} />
			) : (
				children ? (
					<Link to={fileUrl} target="_blank" className={className} download={download}>{children}</Link>
				) : (
					<Link to={fileUrl} target="_blank" className={className} download={download}>{fileObj?.name || "Download file"}</Link>
				)
			)}
		</>
	);
};

export default ProtectedFile;
